export default __webpack_public_path__ + "static/media/leave.8d216302.svg";